<div class="d-flex flex-column spacing-16" style="height: 100%">
  <div class="d-flex justify-content-between align-items-center mb-1">
    <div class="d-flex flex-column">
      <h3 class="h3-bold primary-100">{{ title }}</h3>
      <h4 *ngIf="subtitle" class="h4-reg primary-60">{{ subtitle }}</h4>
    </div>

    <!-- View Mode Toggle (only for line charts) -->
    @if (type === 'line') {
      <div class="view-mode-toggle">
        <app-box-tab
          [showLabel]="false"
          [boxContent]="activeViewModeTabs()"
          (selectedTab)="onViewModeChange($event)"
          Size="medium"></app-box-tab>
      </div>
    }
  </div>

  <div class="d-flex spacing-16 align-items-center">
    <div class="h2-subheaders primary-100">{{ formattedValue() }}</div>
    <app-badges
      [Type]="changeType"
      [IconType]="iconType"
      [withIcon]="true"
      label="{{ isNaN(change()!) ? 'NaN' : change() + '%' }}"></app-badges>
    <div>
      <h3 class="h3-bold primary-100">{{ comparePeriodLabel }}</h3>
    </div>
  </div>

  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="chartOptions()"
    style="width: 100%; display: block; flex-grow: 1; min-height: 0">
  </highcharts-chart>
</div>
